module.exports = __webpack_public_path__ + "static/img/huishengtoujiao_bg.3f4a4c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huishengtoujiao_bg.jpg
// module id = Q22v
// module chunks = 1